const PREFIX = 'conversation-datasheet';

function storageKey(chatbotId, suffix) {
  return `${PREFIX}:${chatbotId}:${suffix}`;
}

function readJson(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

function writeJson(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // ignore quota errors
  }
}

export function loadHiddenColumns(chatbotId) {
  return readJson(storageKey(chatbotId, 'hiddenColumns'), []);
}

export function saveHiddenColumns(chatbotId, columns) {
  writeJson(storageKey(chatbotId, 'hiddenColumns'), columns);
}

export function loadHasDataVars(chatbotId) {
  return readJson(storageKey(chatbotId, 'hasDataVars'), []);
}

export function saveHasDataVars(chatbotId, vars) {
  writeJson(storageKey(chatbotId, 'hasDataVars'), vars);
}

export function loadPeriod(chatbotId) {
  const value = localStorage.getItem(storageKey(chatbotId, 'period'));
  return value || 'all';
}

export function savePeriod(chatbotId, period) {
  try {
    localStorage.setItem(storageKey(chatbotId, 'period'), period);
  } catch {
    // ignore
  }
}

export function loadFilteredMode(chatbotId) {
  return readJson(storageKey(chatbotId, 'filteredMode'), false);
}

export function saveFilteredMode(chatbotId, enabled) {
  writeJson(storageKey(chatbotId, 'filteredMode'), enabled);
}

export function loadColumnOrder(chatbotId) {
  return readJson(storageKey(chatbotId, 'columnOrder'), []);
}

export function saveColumnOrder(chatbotId, order) {
  writeJson(storageKey(chatbotId, 'columnOrder'), order);
}

export function loadShowActions(chatbotId) {
  return readJson(storageKey(chatbotId, 'showActions'), false);
}

export function saveShowActions(chatbotId, enabled) {
  writeJson(storageKey(chatbotId, 'showActions'), enabled);
}

export function loadLastSyncAt(chatbotId) {
  try {
    return localStorage.getItem(storageKey(chatbotId, 'lastSyncAt')) || null;
  } catch {
    return null;
  }
}

export function saveLastSyncAt(chatbotId, isoString) {
  try {
    localStorage.setItem(storageKey(chatbotId, 'lastSyncAt'), isoString);
  } catch {
    // ignore
  }
}

export function loadShowCollectable(chatbotId) {
  const value = readJson(storageKey(chatbotId, 'showCollectable'), true);
  return value !== false;
}

export function saveShowCollectable(chatbotId, enabled) {
  writeJson(storageKey(chatbotId, 'showCollectable'), enabled);
}

export function loadActiveViewId(chatbotId) {
  try {
    return localStorage.getItem(storageKey(chatbotId, 'activeViewId')) || '';
  } catch {
    return '';
  }
}

export function saveActiveViewId(chatbotId, viewId) {
  try {
    if (viewId) {
      localStorage.setItem(storageKey(chatbotId, 'activeViewId'), viewId);
    } else {
      localStorage.removeItem(storageKey(chatbotId, 'activeViewId'));
    }
  } catch {
    // ignore
  }
}

export function loadShowActivity(chatbotId) {
  return readJson(storageKey(chatbotId, 'showActivity'), false);
}

export function saveShowActivity(chatbotId, enabled) {
  writeJson(storageKey(chatbotId, 'showActivity'), enabled);
}

export function loadShowGraph(chatbotId) {
  return readJson(storageKey(chatbotId, 'showGraph'), false);
}

export function saveShowGraph(chatbotId, enabled) {
  writeJson(storageKey(chatbotId, 'showGraph'), enabled);
}

export function loadGraphHighlightVar(chatbotId) {
  try {
    return localStorage.getItem(storageKey(chatbotId, 'graphHighlightVar')) || '';
  } catch {
    return '';
  }
}

export function saveGraphHighlightVar(chatbotId, variable) {
  try {
    if (variable) {
      localStorage.setItem(storageKey(chatbotId, 'graphHighlightVar'), variable);
    } else {
      localStorage.removeItem(storageKey(chatbotId, 'graphHighlightVar'));
    }
  } catch {
    // ignore
  }
}
